import { useCurrentStateAndParams } from "@uirouter/react";

import { SI_SEARCH_ROUTES } from "app/common/constants/ad-intelligence-routes";
import { ROUTES } from "single-spa/react-app/config/solutions25/adIntelligence/searchAdvertising/searchAdvertisingConstants";

export interface ISearchAdsEndpoints {
    table: string;
    excel: string;
    keywordsDrillDown: string;
    domains?: string;
}

const keywordResearchAdsWebsiteEndpoints: ISearchAdsEndpoints = {
    table: "/api/SearchAds/Website/Table",
    excel: "/api/SearchAds/Website/Table/Excel",
    keywordsDrillDown: "/api/SearchAds/Website/KeywordsDrillDown",
};

const keywordResearchAdsKeywordsEndpoints: ISearchAdsEndpoints = {
    table: "/api/SearchAds/Keyword/Table",
    excel: "/api/SearchAds/Keyword/Table/Excel",
    keywordsDrillDown: "/api/SearchAds/Keyword/KeywordsDrillDown",
    domains: "/api/SearchAds/Keyword/Domains",
};

const searchAdvertisingAdsWebsiteEndpoints: ISearchAdsEndpoints = {
    table: "/api/AdIntelligence/Search/SearchAds/Website/Table",
    excel: "/api/AdIntelligence/Search/SearchAds/Website/Table/Excel",
    keywordsDrillDown: "/api/AdIntelligence/Search/SearchAds/Website/KeywordsDrillDown",
};

const searchAdvertisingAdsKeywordsEndpoints: ISearchAdsEndpoints = {
    table: "/api/AdIntelligence/Search/SearchAds/Keyword/Table",
    excel: "/api/AdIntelligence/Search/SearchAds/Keyword/Table/Excel",
    keywordsDrillDown: "/api/AdIntelligence/Search/SearchAds/Keyword/KeywordsDrillDown",
    domains: "/api/AdIntelligence/Search/SearchAds/Keyword/Domains",
};

const searchAdsEndpointsMap: Record<string, ISearchAdsEndpoints> = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    paidsearch_website_ads: keywordResearchAdsWebsiteEndpoints,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    paidsearch_keywordAnalysis_serp_ads: keywordResearchAdsKeywordsEndpoints,
    [ROUTES.textAndShoppingAds]: searchAdvertisingAdsWebsiteEndpoints,
    [ROUTES.keywordAds]: searchAdvertisingAdsKeywordsEndpoints,
    // Sales Intelligence mirror of Search Advertising.
    [SI_SEARCH_ROUTES.textAndShoppingAds]: searchAdvertisingAdsWebsiteEndpoints,
    [SI_SEARCH_ROUTES.keywordAds]: searchAdvertisingAdsKeywordsEndpoints,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    accountreview_website_search_ads: keywordResearchAdsWebsiteEndpoints,
};

export const useSearchAdsEndpoints = (): ISearchAdsEndpoints => {
    const { state } = useCurrentStateAndParams();
    const endpoints = searchAdsEndpointsMap[state.name];

    if (!endpoints) {
        throw new Error(
            `No search ads endpoints configured for state: ${state.name}. ` +
                `Available states: ${Object.keys(searchAdsEndpointsMap).join(", ")}`,
        );
    }

    return endpoints;
};
